module.exports = __webpack_public_path__ + "static/media/05_atw_weihnachtskarte.bc0179b6.svg";